import React from 'react';

const UserAvatar = ({ className, width, height, ...r }) => {
	return (
		<svg
			className={className}
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 48 48"
			style={{ width, height }}
			{...r}
		>
			<path
				fill="#FFC968"
				d="M23.39 48A23.442 23.442 0 100 24.558 23.416 23.416 0 0023.39 48z"
			></path>
			<path
				fill="#272727"
				d="M18.08 20.333a.866.866 0 01-.744-.423 4.293 4.293 0 00-7.378 0 .868.868 0 01-1.488-.893 6.028 6.028 0 0110.355 0 .87.87 0 01-.744 1.316zm19.737 0a.866.866 0 01-.745-.423 4.293 4.293 0 00-7.378 0 .868.868 0 11-1.488-.893 6.028 6.028 0 0110.356 0 .87.87 0 01-.745 1.316zM23.515 33.111A18.284 18.284 0 0110.53 27.73a.868.868 0 111.228-1.228 16.622 16.622 0 0023.517 0 .868.868 0 111.228 1.228 18.289 18.289 0 01-12.988 5.381z"
			></path>
		</svg>
	);
};

export default UserAvatar;
